import React from "react";
import { GUEST_FIELD_LABEL_CLASS, guestLocationId } from "../guestVezoUtils";

const selectClass =
  "w-full min-h-[2.5rem] rounded-lg border border-slate-300 bg-white px-3 py-2 text-base text-slate-900 shadow-sm focus:border-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-600/20 sm:text-sm";

/**
 * Location field for guest Vezo flow (used inside the shared wizard shell).
 * @param {string} [practiceName] — from locations API (e.g. practice_name)
 * @param {(location: object | null) => void} [onLocationChange]
 */
export default function GuestLocationStep({
  locations = [],
  locationPick = "",
  locationsLoading = false,
  practiceName = "",
  onLocationChange,
  className = "",
}) {
  return (
    <div className={className} aria-labelledby="guest-location-heading">
      <div className="space-y-3">
        {practiceName ? (
          <div
            className="rounded-xl border border-teal-200/80 bg-gradient-to-br from-teal-50/90 to-slate-50/80 px-2 py-2 shadow-sm ring-1 ring-teal-600/10 sm:px-4 sm:py-3.5"
            role="status"
          >
            <p className="text-lg font-bold leading-tight tracking-tight text-slate-900 sm:text-xl">
              {practiceName}
            </p>
          </div>
        ) : null}
        <label htmlFor="guest-location" className={GUEST_FIELD_LABEL_CLASS}>
          Practice location
        </label>
        {locationsLoading && !locationPick ? (
          <p className="text-xs text-slate-500 sm:text-sm">Loading locations…</p>
        ) : null}
        <select
          id="guest-location"
          className={selectClass}
          value={locationPick}
          disabled={locationsLoading && !locationPick && locations.length === 0}
          onChange={(e) => {
            const id = e.target.value;
            if (!id) {
              onLocationChange?.(null);
              return;
            }
            const loc = locations.find((l) => guestLocationId(l) === String(id));
            onLocationChange?.(loc ?? null);
          }}
        >
          <option value="">Select a location</option>
          {locations.map((loc, idx) => {
            const vid = guestLocationId(loc);
            return (
              <option key={vid || `loc-${idx}`} value={vid}>
                {loc.name || loc.location_name || (vid ? `Location ${vid}` : `Location ${idx + 1}`)}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
}
